import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ROUTES } from "@/constants/routes";
import { FullScreenLoader } from "@/components/organisms/FullScreenLoader";

/**
 * Envolve todas as rotas que exigem sessão ativa (Home, Jogos, Grupos...).
 * Se não autenticado, redireciona para o Login preservando a rota de origem
 * (para retorno pós-login).
 */
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <FullScreenLoader />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
